// extracted by mini-css-extract-plugin
export default {"article":"Szma5dRf9jPS8BHDP3kl","description":"qpExMEV47OSjyVIlPT0P","imageWrapper":"Z6zHEWZkkYNMc6FEGJHQ"};